import * as React from 'react';
import { Redirect } from 'react-router-dom';
import Fullscreen from '../../service/FullScreen'
import * as Session from '../../service/Session';
import * as Dispatch from '../../service/Dispatcher';
import { RouteComponentProps } from 'react-router';
//import * as API from '../../service/apisvc';


//type LogoutProps = Session.LoginState & RouteComponentProps<{}>;
type LogoutProps = Session.UserState & RouteComponentProps<{}>;


//export class Logout extends React.Component<LogoutProps, Session.UserState> {
export class Logout extends React.Component<RouteComponentProps<{}>, Session.UserState> {
    //constructor(props: LogoutProps | undefined) {
    constructor(props: RouteComponentProps<{}> ) {
        super(props);
        this.state = { ...this.userStateRestore() };
    }

    userStateRestore() {
        let _user = Session.currentUser();
        if (_user)
            return _user;
        else
            return { identityState: Session.AnonimousIdentityState };
    }


    componentDidMount() {
        this._logout();
    }

    getState = () => {
        return this.state;
    }

    dispatch = (action: Session.LoginAction) => {
        //return Dispatch.LoginDispatcher(this, action);
        let _user = this.userStateRestore();
        this.setState(_user);
        return {};
    }

    _logout = () => {
        Session.accountActions.logout(this.getState, this.dispatch);
    }

    render() {
        if (this.state.identityState.isAuthenticated) {
            return (
                <Fullscreen>
                    <div className="container">Logging out....</div>
                </Fullscreen>
            );
        } else {
            return <Redirect to="/" />;
        }
    }
}
